import React, {useEffect, useState } from "react";
import { getAllQualificationsAsync } from "../services/qualificationService";
import { createNewAccountAsync, getAllNationalityAsync, getExactSpecializationsAsync } from "../services/employeeService";
import OverlayLoadingSpinner from "../components/OverlayLoadingSpinner";
 import { useNavigate } from "react-router-dom";
import { Modal , Button as RBButton  } from "react-bootstrap";
import Select from "react-select";

const Register = () => {
    const navigate = useNavigate();
const [isCreateConfirmOpen, setIsCreateConfirmOpen] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    qualificationId: "",
    nationalityId: "",
    exactSpecializationId: "",
    idNumber: "",
    phone: "",
    empNumber: "",
    email: "",
    gender: "",
    empType: "",
    isActive: false,
    isEmpCreateAccount : true,
    hireDate: "",
    workStartDate: "",
  });

  const [emailCreated, setEmailCreated] = useState("");
  const [errors, setErrors] = useState({});
  const [qualifications, setQualifications] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [exactSpecializations, setExactSpecializations] = useState([]);
  const [newEmp, setNewEmp] = useState([]);
  const [success, setSuccess] = useState("");
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const getInitalData = async () => {
    
    const [
      qualifications,
      nationality,
      exactSpecializations,
    ] = await Promise.all([getAllQualificationsAsync(), getAllNationalityAsync(), getExactSpecializationsAsync()]);
    setQualifications(qualifications);
    setNationality(nationality);
    setExactSpecializations(exactSpecializations);
  };
  const selectStyles = {
    option: (base) => ({ ...base, color: "#212529" }),
    singleValue: (base) => ({ ...base, color: "#212529" }),
    input: (base) => ({ ...base, color: "#212529" }),
  };

  const handleSelectChange = (name, selectedOption) => {
    setFormData({ ...formData, [name]: selectedOption ? selectedOption.value : "" });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === "checkbox" ? checked : value;
    if (name === "isActive") {
      val = value === "true";  
    }
    setFormData({ ...formData, [name]: val });
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields check
    if (!formData.name.trim()) {
      newErrors.name = "هذا الحقل مطلوب";
    }
    if (!formData.idNumber.trim()) {
      newErrors.idNumber = "هذا الحقل مطلوب";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "هذا الحقل مطلوب";
    }
    if (!formData.email.trim()) {
      newErrors.email = "هذا الحقل مطلوب";
    }
    if (!formData.gender.trim()) {
      newErrors.gender = "هذا الحقل مطلوب";
    }
    if (!formData.empType.trim()) {
      newErrors.empType = "هذا الحقل مطلوب";
    }

    // Phone validation: starts with '05' and exactly 10 digits
    if (formData.phone) {
      const phoneRegex = /^05\d{8}$/; // 05 + 8 digits = total 10
      if (!phoneRegex.test(formData.phone)) {
        newErrors.phone = "رقم الجوال يجب أن يبدأ بـ 05 ويتكون من 10 أرقام.";
      }
    }

    // Email validation: must end with '@o.edu.sa'
    if (formData.email && !formData.email.endsWith("@oc.edu.sa")) {
      newErrors.email = "البريد الإلكتروني يجب أن ينتهي بـ oc.edu.sa@";
    }
 
    return newErrors;
  };

  const cleanFormData = (data) => {
    return Object.fromEntries(
      Object.entries(data).map(([key, value]) => [
        key,
        typeof value === "string" && value.trim() === "" ? null : value
      ])
    );
  };
  

  const handleSubmit = (e) => {
  e.preventDefault();
  setApiError("");
  setSuccess("");
  setErrors({});

  const formErrors = validateForm();
  setErrors(formErrors);

  if (Object.keys(formErrors).length === 0) {
    setIsCreateConfirmOpen(true);
  }
};
const handleConfirmCancel = () => {
  setIsCreateConfirmOpen(false);  
};

const handleConfirmSubmit = async () => {
  // close modal then call API
  setIsCreateConfirmOpen(false);

  setLoading(true);
  setApiError("");
  setSuccess("");

  try {
    const cleanedData = cleanFormData(formData);
    const res = await createNewAccountAsync(cleanedData);

    if (res.isSuccess) {
      setSuccess("تم انشاء حساب بنجاح");
      setEmailCreated(formData.email) 
      setFormData({
        name: "",
        qualificationId: "",
        nationalityId: "",
        exactSpecializationId: "",
        idNumber: "",
        phone: "",
        empNumber: "",
        email: "",
        gender: "",
        empType: "",
        isActive: false,
        isEmpCreateAccount: true,
        hireDate: "",
        workStartDate: "",
      });
    } else {
      setErrors(res?.message || "تعذر إنشاء الحساب");
    }
  } catch (error) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setApiError(error.message || "حدث خطأ أثناء إنشاء الموظف");
  } finally {
    setLoading(false);
  }
};

  useEffect(()=>{
getInitalData();
  },[])

  return (
    <div className="container">

      <div className="container" style={{ width: "60%", margin: "0 auto" }}>
        <h3 className="text-center mt-4 mb-4 color-primary">إنشاء حساب جديد</h3>
        {apiError && 
        <div className="alert alert-danger">{apiError}</div>
        }
        {success &&
         <div className="alert alert-success">
        <h5 className="fw-bold">
            {success}
          <hr />
        تم ارسال كلمة المرور على الايميل : 
        {emailCreated}
        </h5>
        </div> }
        {loading && <OverlayLoadingSpinner/>}
        <div className="primary-bg p-4 rounded">

          {/* ── المعلومات الشخصية ── */}
          <h6 className="color-primary mb-3 border-bottom pb-2">المعلومات الشخصية</h6>

          <div className="mb-3 row">
            <div className="col-md-6">
              <label htmlFor="name" className="color-primary">الاسم</label>
              <input
                type="text"
                name="name"
                id="name"
                className={`form-control ${errors.name ? "is-invalid" : ""}`}
                value={formData.name}
                onChange={handleChange}
                placeholder="أدخل الاسم"
              />
              {errors.name && <div className="invalid-feedback">{errors.name}</div>}
            </div>

            <div className="col-md-6">
              <label htmlFor="idNumber" className="color-primary">رقم الهوية</label>
              <input
                type="text"
                name="idNumber"
                id="idNumber"
                maxLength={20}
                className={`form-control ${errors.idNumber ? "is-invalid" : ""}`}
                value={formData.idNumber}
                onChange={handleChange}
                placeholder="أدخل رقم الهوية"
              />
              {errors.idNumber && <div className="invalid-feedback">{errors.idNumber}</div>}
            </div>
          </div>

          <div className="mb-3 row">
            <div className="col-md-6">
              <label htmlFor="phone" className="color-primary">رقم الجوال</label>
              <input
                type="text"
                name="phone"
                id="phone"
                maxLength={10}
                className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                value={formData.phone}
                onChange={handleChange}
                placeholder="05xxxxxxxx"
              />
              {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
            </div>

            <div className="col-md-6">
              <label htmlFor="email" className="color-primary">البريد الإلكتروني</label>
              <input
                type="text"
                name="email"
                id="email"
                maxLength={50}
                className={`form-control ${errors.email ? "is-invalid" : ""}`}
                value={formData.email}
                onChange={handleChange}
                placeholder="example@oc.edu.sa"
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>
          </div>

          <div className="mb-3 row">
            <div className="col-md-6">
              <label htmlFor="gender" className="color-primary">الجنس</label>
              <select
                name="gender"
                id="gender"
                className={`form-control ${errors.gender ? "is-invalid" : ""}`}
                value={formData.gender}
                onChange={handleChange}
              >
                <option value="">--اختر--</option>
                <option value="male">ذكر</option>
                <option value="female">أنثى</option>
              </select>
              {errors.gender && <div className="invalid-feedback">{errors.gender}</div>}
            </div>

            <div className="col-md-6">
              <label htmlFor="nationalityId" className="color-primary">الجنسية</label>
              <Select
                inputId="nationalityId"
                options={nationality.map((n) => ({ value: n.nationalityId, label: n.name }))}
                value={nationality.map((n) => ({ value: n.nationalityId, label: n.name })).find((o) => o.value === Number(formData.nationalityId)) || null}
                onChange={(opt) => handleSelectChange("nationalityId", opt)}
                placeholder="-- اختر --"
                isRtl={true}
                noOptionsMessage={() => "لا توجد نتائج"}
                styles={selectStyles}
              />
            </div>
          </div>

          {/* ── المعلومات الوظيفية والأكاديمية ── */}
          <h6 className="color-primary mb-3 border-bottom pb-2 mt-4">المعلومات الوظيفية والأكاديمية</h6>

          <div className="mb-3 row">
            <div className="col-md-6">
              <label htmlFor="empType" className="color-primary">مجال العمل</label>
              <select
                name="empType"
                id="empType"
                className={`form-control ${errors.empType ? "is-invalid" : ""}`}
                value={formData.empType}
                onChange={handleChange}
              >
                <option value="">--اختر--</option>
                <option value="FacultyMember">عضو هيئة تدريس</option>
                <option value="Administrative">إداري</option>
                <option value="Technician">فني</option>
              </select>
              {errors.empType && <div className="invalid-feedback">{errors.empType}</div>}
            </div>

            <div className="col-md-6">
              <label htmlFor="empNumber" className="color-primary">رقم الموظف</label>
              <input
                type="text"
                name="empNumber"
                id="empNumber"
                maxLength={20}
                className="form-control"
                value={formData.empNumber}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="mb-3 row">
            <div className="col-md-6">
              <label htmlFor="qualificationId" className="color-primary">المؤهل</label>
              <select
                name="qualificationId"
                id="qualificationId"
                className="form-control"
                value={formData.qualificationId}
                onChange={handleChange}
              >
                <option value="">--اختر--</option>
                {qualifications.map((q) => (
                  <option key={q.qualificationId} value={q.qualificationId}>
                    {q.qualificationName}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6">
              <label htmlFor="exactSpecializationId" className="color-primary">التخصص الدقيق</label>
              <Select
                inputId="exactSpecializationId"
                options={exactSpecializations.map((s) => ({ value: s.exactSpecializationId, label: s.name }))}
                value={exactSpecializations.map((s) => ({ value: s.exactSpecializationId, label: s.name })).find((o) => o.value === Number(formData.exactSpecializationId)) || null}
                onChange={(opt) => handleSelectChange("exactSpecializationId", opt)}
                placeholder="-- اختر --"
                isClearable={true}
                isRtl={true}
                noOptionsMessage={() => "لا توجد نتائج"}
                styles={selectStyles}
              />
            </div>
          </div>

          <div className="text-center mt-4">
              <button
                onClick={handleSubmit}
                type="submit"
                className="mt-4 button-md secondary-outline-bg   col-12"
                disabled={loading}
              >
                {loading ? "جارٍ الإنشاء..." : "انشاء"}
              </button>
               <button 
               onClick={()=>navigate('/login')} 
               type="submit"  className="mt-4 button-md  secondary-outline-bg   col-12">
              رجوع
            </button>
          </div>
        </div>
      </div>
 <Modal
  show={isCreateConfirmOpen}
  onHide={handleConfirmCancel}
  centered
  backdrop="static"
  keyboard={!loading}
  dir="rtl"
>
  <Modal.Header closeButton={!loading}>
    <Modal.Title>تأكيد إنشاء الحساب</Modal.Title>
  </Modal.Header>

  <Modal.Body>
      <div className="text-center py-3">
    <p className="mb-3 text-lg fw-semibold text-dark">
      سيتم إنشاء حساب جديد بالمعلومات التالية:
    </p>

    <div className="p-3 rounded bg-light border mb-3">
      <p className="mb-2 fs-5">
        <strong>رقم الهوية:</strong>
      </p>
      <p className="fs-5 secondary-color fw-bold">
        {formData.idNumber || "—"}
      </p>
    </div>

    <div className="p-3 rounded bg-light border">
      <p className="mb-2 fs-5">
        <strong>البريد الإلكتروني:</strong>
      </p>
      <p className="fs-5 secondary-color fw-bold">
        {formData.email || "—"}
      </p>
    </div>
  </div>
  </Modal.Body>

  <Modal.Footer className="gap-2">
    <RBButton 
      variant="outline-secondary"
      onClick={handleConfirmCancel}
      disabled={loading}
    >
      إلغاء
    </RBButton>

    <RBButton
      onClick={handleConfirmSubmit}
      disabled={loading}
      className="primary-bg primary-bg-hover border-0"
    >
      {loading ? "جارٍ الإنشاء..." : "تأكيد"}
    </RBButton>
  </Modal.Footer>
</Modal>


    </div>

  );
}

 
export default Register;
